import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const staffDashboardService = {
  getMyClients: async () => {
    return api.getCall("/api/staffDashboard/my-clients");
  },

  getClientCst: async (clientId) => {
    return api.getCall(`/api/staffDashboard/my-clients/${clientId}/cst`);
  },

  getMyShiftsToday: async () => {
    return api.getCall("/api/staffDashboard/my-shifts/today");
  },

  getMyShiftsUpcoming: async () => {
    return api.getCall("/api/staffDashboard/my-shifts/upcoming");
  },
};
